import { ReactElement } from 'react';
import { Pagination } from '@client/common/components/Pagination';
import { useTranslate } from '@client/i18n/hooks';
import { BackButton } from '@client/myAccount/common/components/BackButton';
import { MyAccountCardBox } from '@client/myAccount/common/components/MyAccountCardBox';
import { UsersTable } from '@client/myAccount/costCenters/components/common/UsersTable';
import { CARD_BOX_TITLE_SIZE } from 'b2b-components/theme/components/CardBox';
import { getCostCenterUsersLabel } from 'b2b-common/core/utils/costCenters/getUserDisplayText';
import { HeaderButtons } from './HeaderButtons';
import { Props } from './ListPage.types';
import './ListPage.scss';

export const ListPage = ({
  backButtonUrl,
  data,
  page,
  onPageChange,
  id,
  description,
  onAdd,
  onEdit,
  onRemove,
}: Props): ReactElement => {
  const t = useTranslate();
  const { costCenter, total, data: usersData, pageSize } = data;
  const userRole = data?.costCenter?.userRoleInCostCenter;
  const displayTitle = getCostCenterUsersLabel(userRole, t);

  return (
    <div className='UsersListPage'>
      <BackButton
        className='MyAccount-BackButton--TopSide'
        url={backButtonUrl}
      >
        {t('Back to cost center overview')}
      </BackButton>

      <MyAccountCardBox
        title={`${displayTitle} - ${id}`}
        titleQuantity={total}
        titleSize={CARD_BOX_TITLE_SIZE.large}
        actionButton={{
          customComponent: (
            <HeaderButtons
              handleAddUserClick={onAdd}
              canCreateUser={!!costCenter?.canCreateUser}
            />),
        }}
      >
        {description ? (
          <div className='UsersListPage-Description'>
            {t('Additional users can be added here to access the registered customer number. Different authorization levels are available. Each user has their own shopping cart and their own shareable shopping lists.')}
          </div>
        ) : null}
        <UsersTable
          users={usersData}
          costCenter={costCenter}
          onEdit={onEdit}
          onRemove={onRemove}
        />
      </MyAccountCardBox>

      <Pagination
        className='MyAccount-Pagination'
        total={Math.ceil(total / pageSize)}
        page={page}
        onPageChange={onPageChange}
        areButtonsVisible={usersData.length > 0}
      />

      <BackButton
        className='MyAccount-BackButton--BottomSide'
        url={backButtonUrl}
      >
        {t('Back to cost center overview')}
      </BackButton>

    </div>
  );
};
